/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ENUM_ANKET_SOURCE {
  manual = "manual",
}

export enum ENUM_INDICATOR_SOURCE {
  document = "document",
  manual = "manual",
}

export enum ENUM_USERSPERMISSIONSUSER_GENDER {
  female = "female",
  male = "male",
}

export interface AnketFiltersInput {
  documentId?: IDFilterInput | null;
  identifier?: StringFilterInput | null;
  value?: StringFilterInput | null;
  user?: UsersPermissionsUserFiltersInput | null;
  date?: DateTimeFilterInput | null;
  source?: StringFilterInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (AnketFiltersInput | null)[] | null;
  or?: (AnketFiltersInput | null)[] | null;
  not?: AnketFiltersInput | null;
}

export interface AnketInput {
  identifier?: string | null;
  value?: string | null;
  user?: string | null;
  date?: any | null;
  source?: ENUM_ANKET_SOURCE | null;
  publishedAt?: any | null;
}

export interface BooleanFilterInput {
  and?: (boolean | null)[] | null;
  or?: (boolean | null)[] | null;
  not?: BooleanFilterInput | null;
  eq?: boolean | null;
  eqi?: boolean | null;
  ne?: boolean | null;
  nei?: boolean | null;
  startsWith?: boolean | null;
  endsWith?: boolean | null;
  contains?: boolean | null;
  notContains?: boolean | null;
  containsi?: boolean | null;
  notContainsi?: boolean | null;
  gt?: boolean | null;
  gte?: boolean | null;
  lt?: boolean | null;
  lte?: boolean | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (boolean | null)[] | null;
  notIn?: (boolean | null)[] | null;
  between?: (boolean | null)[] | null;
}

export interface DateFilterInput {
  and?: (any | null)[] | null;
  or?: (any | null)[] | null;
  not?: DateFilterInput | null;
  eq?: any | null;
  eqi?: any | null;
  ne?: any | null;
  nei?: any | null;
  startsWith?: any | null;
  endsWith?: any | null;
  contains?: any | null;
  notContains?: any | null;
  containsi?: any | null;
  notContainsi?: any | null;
  gt?: any | null;
  gte?: any | null;
  lt?: any | null;
  lte?: any | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (any | null)[] | null;
  notIn?: (any | null)[] | null;
  between?: (any | null)[] | null;
}

export interface DateTimeFilterInput {
  and?: (any | null)[] | null;
  or?: (any | null)[] | null;
  not?: DateTimeFilterInput | null;
  eq?: any | null;
  eqi?: any | null;
  ne?: any | null;
  nei?: any | null;
  startsWith?: any | null;
  endsWith?: any | null;
  contains?: any | null;
  notContains?: any | null;
  containsi?: any | null;
  notContainsi?: any | null;
  gt?: any | null;
  gte?: any | null;
  lt?: any | null;
  lte?: any | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (any | null)[] | null;
  notIn?: (any | null)[] | null;
  between?: (any | null)[] | null;
}

export interface DeleteAccountInput {
  phone?: string | null;
  email?: string | null;
  publishedAt?: any | null;
}

export interface FloatFilterInput {
  and?: (number | null)[] | null;
  or?: (number | null)[] | null;
  not?: FloatFilterInput | null;
  eq?: number | null;
  eqi?: number | null;
  ne?: number | null;
  nei?: number | null;
  startsWith?: number | null;
  endsWith?: number | null;
  contains?: number | null;
  notContains?: number | null;
  containsi?: number | null;
  notContainsi?: number | null;
  gt?: number | null;
  gte?: number | null;
  lt?: number | null;
  lte?: number | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (number | null)[] | null;
  notIn?: (number | null)[] | null;
  between?: (number | null)[] | null;
}

export interface IDFilterInput {
  and?: (string | null)[] | null;
  or?: (string | null)[] | null;
  not?: IDFilterInput | null;
  eq?: string | null;
  eqi?: string | null;
  ne?: string | null;
  nei?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  contains?: string | null;
  notContains?: string | null;
  containsi?: string | null;
  notContainsi?: string | null;
  gt?: string | null;
  gte?: string | null;
  lt?: string | null;
  lte?: string | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (string | null)[] | null;
  notIn?: (string | null)[] | null;
  between?: (string | null)[] | null;
}

export interface IndicatorFiltersInput {
  documentId?: IDFilterInput | null;
  source?: StringFilterInput | null;
  user?: UsersPermissionsUserFiltersInput | null;
  value?: FloatFilterInput | null;
  date?: DateTimeFilterInput | null;
  identifier?: StringFilterInput | null;
  message?: StringFilterInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (IndicatorFiltersInput | null)[] | null;
  or?: (IndicatorFiltersInput | null)[] | null;
  not?: IndicatorFiltersInput | null;
}

export interface IndicatorInput {
  source?: ENUM_INDICATOR_SOURCE | null;
  user?: string | null;
  value?: number | null;
  date?: any | null;
  identifier?: string | null;
  message?: string | null;
  publishedAt?: any | null;
}

export interface JSONFilterInput {
  and?: (any | null)[] | null;
  or?: (any | null)[] | null;
  not?: JSONFilterInput | null;
  eq?: any | null;
  eqi?: any | null;
  ne?: any | null;
  nei?: any | null;
  startsWith?: any | null;
  endsWith?: any | null;
  contains?: any | null;
  notContains?: any | null;
  containsi?: any | null;
  notContainsi?: any | null;
  gt?: any | null;
  gte?: any | null;
  lt?: any | null;
  lte?: any | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (any | null)[] | null;
  notIn?: (any | null)[] | null;
  between?: (any | null)[] | null;
}

export interface PaginationArg {
  page?: number | null;
  pageSize?: number | null;
  start?: number | null;
  limit?: number | null;
}

export interface StoryFiltersInput {
  documentId?: IDFilterInput | null;
  identifier?: StringFilterInput | null;
  user?: UsersPermissionsUserFiltersInput | null;
  description?: StringFilterInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (StoryFiltersInput | null)[] | null;
  or?: (StoryFiltersInput | null)[] | null;
  not?: StoryFiltersInput | null;
}

export interface StoryInput {
  identifier?: string | null;
  user?: string | null;
  description?: string | null;
  file?: string | null;
  publishedAt?: any | null;
}

export interface StringFilterInput {
  and?: (string | null)[] | null;
  or?: (string | null)[] | null;
  not?: StringFilterInput | null;
  eq?: string | null;
  eqi?: string | null;
  ne?: string | null;
  nei?: string | null;
  startsWith?: string | null;
  endsWith?: string | null;
  contains?: string | null;
  notContains?: string | null;
  containsi?: string | null;
  notContainsi?: string | null;
  gt?: string | null;
  gte?: string | null;
  lt?: string | null;
  lte?: string | null;
  null?: boolean | null;
  notNull?: boolean | null;
  in?: (string | null)[] | null;
  notIn?: (string | null)[] | null;
  between?: (string | null)[] | null;
}

export interface UsersPermissionsPermissionFiltersInput {
  documentId?: IDFilterInput | null;
  action?: StringFilterInput | null;
  role?: UsersPermissionsRoleFiltersInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (UsersPermissionsPermissionFiltersInput | null)[] | null;
  or?: (UsersPermissionsPermissionFiltersInput | null)[] | null;
  not?: UsersPermissionsPermissionFiltersInput | null;
}

export interface UsersPermissionsRoleFiltersInput {
  documentId?: IDFilterInput | null;
  name?: StringFilterInput | null;
  description?: StringFilterInput | null;
  type?: StringFilterInput | null;
  permissions?: UsersPermissionsPermissionFiltersInput | null;
  users?: UsersPermissionsUserFiltersInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (UsersPermissionsRoleFiltersInput | null)[] | null;
  or?: (UsersPermissionsRoleFiltersInput | null)[] | null;
  not?: UsersPermissionsRoleFiltersInput | null;
}

export interface UsersPermissionsUserFiltersInput {
  documentId?: IDFilterInput | null;
  username?: StringFilterInput | null;
  email?: StringFilterInput | null;
  provider?: StringFilterInput | null;
  confirmed?: BooleanFilterInput | null;
  blocked?: BooleanFilterInput | null;
  role?: UsersPermissionsRoleFiltersInput | null;
  paidTill?: DateTimeFilterInput | null;
  FIO?: StringFilterInput | null;
  gender?: StringFilterInput | null;
  birthdate?: DateFilterInput | null;
  widget?: JSONFilterInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (UsersPermissionsUserFiltersInput | null)[] | null;
  or?: (UsersPermissionsUserFiltersInput | null)[] | null;
  not?: UsersPermissionsUserFiltersInput | null;
}

export interface UsersPermissionsUserInput {
  username?: string | null;
  email?: string | null;
  provider?: string | null;
  confirmed?: boolean | null;
  blocked?: boolean | null;
  role?: string | null;
  paidTill?: any | null;
  FIO?: string | null;
  gender?: ENUM_USERSPERMISSIONSUSER_GENDER | null;
  birthdate?: any | null;
  avatar?: string | null;
  widget?: any | null;
  publishedAt?: any | null;
  password?: string | null;
}

export interface WidgetFiltersInput {
  documentId?: IDFilterInput | null;
  user?: UsersPermissionsUserFiltersInput | null;
  identifier?: StringFilterInput | null;
  date?: DateTimeFilterInput | null;
  value?: FloatFilterInput | null;
  message?: StringFilterInput | null;
  createdAt?: DateTimeFilterInput | null;
  updatedAt?: DateTimeFilterInput | null;
  publishedAt?: DateTimeFilterInput | null;
  and?: (WidgetFiltersInput | null)[] | null;
  or?: (WidgetFiltersInput | null)[] | null;
  not?: WidgetFiltersInput | null;
}

export interface profileBaseInput {
  FIO: string;
  gender: ENUM_USERSPERMISSIONSUSER_GENDER;
  birthdate: any;
  email: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
